import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Instagram, ArrowUpRight } from 'lucide-react';
import BookingModal from '../components/BookingModal';

// Blown.co.in salon images for the header slideshow (without logo image)
const headerImages = [
  'https://static.wixstatic.com/media/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/486953_d95f0250583148d58110648b1d58b4fc~mv2.jpeg',
  'https://static.wixstatic.com/media/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/486953_3b99a1aec9184dca9d620eaa8540c766~mv2.jpeg',
  'https://static.wixstatic.com/media/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg/v1/fill/w_1200,h_1800,al_c,q_85,enc_avif,quality_auto/486953_c687dbc962924dd8b086aa4e8133d25e~mv2.jpeg',
  'https://static.wixstatic.com/media/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg/v1/fill/w_1200,h_900,al_c,q_85,enc_avif,quality_auto/5df0bd_dab9ff5017f643f3bb0e5441471366df~mv2.jpeg',
];

const galleryImages = [
  {
    url: 'https://images.pexels.com/photos/7195811/pexels-photo-7195811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=600',
    alt: 'Premium salon interior with styling chairs',
    category: 'Studio',
  },
  {
    url: 'https://images.pexels.com/photos/7195803/pexels-photo-7195803.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=600',
    alt: 'Modern beauty salon with elegant furniture',
    category: 'Interior',
  },
  {
    url: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Professional gel manicure service',
    category: 'Nail Art',
  },
  {
    url: 'https://images.unsplash.com/photo-1772235616130-b80e12f0ab7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxleWVsYXNoJTIwZXh0ZW5zaW9uJTIwYmVhdXR5JTIwdHJlYXRtZW50fGVufDB8fHx8MTc3NDQ3NDgyNnww&ixlib=rb-4.1.0&q=85',
    alt: 'Eyelash extension application',
    category: 'Lash Extensions',
  },
  {
    url: 'https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Professional manicure session',
    category: 'Manicure',
  },
  {
    url: 'https://images.unsplash.com/photo-1709477542153-5bedab2b5657?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxleWVsYXNoJTIwZXh0ZW5zaW9uJTIwYmVhdXR5JTIwdHJlYXRtZW50fGVufDB8fHx8MTc3NDQ3NDgyNnww&ixlib=rb-4.1.0&q=85',
    alt: 'Makeup application service',
    category: 'Permanent Makeup',
  },
  {
    url: 'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Eyebrow microblading procedure',
    category: 'Microblading',
  },
  {
    url: 'https://images.pexels.com/photos/3997379/pexels-photo-3997379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'BB Glow treatment',
    category: 'BB Glow',
  },
  {
    url: 'https://images.unsplash.com/photo-1633681140152-3b8726450518?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwYmVhdXR5JTIwc2Fsb24lMjBpbnRlcmlvciUyMGRhcmslMjBlbGVnYW50fGVufDB8fHx8MTc3NDQ3NDgxNXww&ixlib=rb-4.1.0&q=85',
    alt: 'White elegant salon interior',
    category: 'Lounge',
  },
  {
    url: 'https://images.unsplash.com/photo-1761931403663-050fbd8fb4c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxoYWlyJTIwc2Fsb24lMjBzdHlsaW5nJTIwY2hhaXIlMjBtaXJyb3J8ZW58MHx8fHwxNzc0NDc0ODE3fDA&ixlib=rb-4.1.0&q=85',
    alt: 'Hair styling session',
    category: 'Hair Studio',
  },
  {
    url: 'https://images.pexels.com/photos/3762879/pexels-photo-3762879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Lip shading treatment',
    category: 'PMU Services',
  },
  {
    url: 'https://images.pexels.com/photos/5128220/pexels-photo-5128220.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    alt: 'Eyelash treatment close-up',
    category: 'Lash Bar',
  },
];

const GalleryPage = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>Gallery - BLR Nail Club | Nail Art, Salon Interior & Beauty Work Photos</title>
        <meta name="description" content="Explore our gallery of stunning nail art designs, gel extensions, lash work, and premium salon interiors. See why BLR Nail Club is Bangalore's top-rated beauty studio." />
        <meta name="keywords" content="nail art gallery Bangalore, nail designs photos, lash extensions gallery, salon interior photos, beauty work portfolio" />
        <link rel="canonical" href="https://www.blrnailclub.in/gallery" />
        <meta property="og:title" content="Gallery - BLR Nail Club Bangalore" />
        <meta property="og:description" content="Stunning nail art, gel extensions & beauty work. See our portfolio!" />
        <meta property="og:url" content="https://www.blrnailclub.in/gallery" />
      </Helmet>
      
      <main className="bg-black min-h-screen" data-testid="gallery-page">
      {/* Our Stores Sneak Peek Section */}
      <div className="pt-24 pb-4 bg-black">
        <h2 
          className="text-center text-4xl md:text-5xl lg:text-6xl font-bold tracking-wider"
          style={{ 
            background: 'linear-gradient(135deg, #D4AF37 0%, #B8860B 50%, #D4AF37 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 0 30px rgba(184, 134, 11, 0.3)'
          }}
        >
          OUR STORES SNEAK PEEK
        </h2>
      </div>
      
      {/* Scrolling Image Strip - Landscape full width video-like banner */}
      <div className="bg-black overflow-hidden h-[30vh] md:h-[40vh]">
        <div className="flex animate-gallery-scroll h-full">
          {[...headerImages, ...headerImages, ...headerImages].map((img, i) => (
            <img 
              key={i} 
              src={img} 
              alt="Salon" 
              className="h-full w-auto object-cover flex-shrink-0"
            />
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section className="pt-12 pb-16 md:pb-24 bg-black">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <p className="text-[#B8860B] text-xs tracking-[0.3em] uppercase mb-4 font-light">Our Work</p>
          <h1 className="text-white text-5xl md:text-6xl font-light tracking-wide mb-6">
            Gallery
          </h1>
          <p className="text-white/60 text-base md:text-lg font-light max-w-2xl mx-auto">
            Browse through our collection of stunning salon interiors, nail art, and beauty 
            transformations created by our expert artisans.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 md:py-24 bg-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Masonry Grid */}
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="break-inside-avoid group relative overflow-hidden"
                data-testid={`gallery-image-${index}`}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                    index % 3 === 0 ? 'h-80' : index % 3 === 1 ? 'h-64' : 'h-72'
                  }`}
                  loading="lazy"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-end">
                  <div className="p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <span className="text-[#B8860B] text-xs uppercase tracking-[0.2em]">{image.category}</span>
                    <p className="text-white text-sm font-light mt-1">{image.alt}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram CTA */}
      <section className="py-16 md:py-24 bg-black border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <p className="text-[#B8860B] text-xs tracking-[0.3em] uppercase mb-4 font-light">Follow Us</p>
          <h2 className="text-white text-3xl md:text-4xl font-light tracking-wide mb-6">
            More Inspiration on Instagram
          </h2>
          <p className="text-white/60 font-light mb-8">
            Follow us for daily nail inspiration, behind-the-scenes content, and exclusive offers.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.instagram.com/blr_nailclub/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 border border-white/30 text-white px-8 py-4 text-sm uppercase tracking-[0.15em] font-medium hover:border-[#B8860B] hover:text-[#B8860B] transition-colors"
              data-testid="gallery-instagram-link"
            >
              <Instagram strokeWidth={1.5} size={20} />
              @blr_nailclub
            </a>
            <button
              onClick={() => setIsBookingModalOpen(true)}
              className="inline-flex items-center justify-center gap-3 bg-[#B8860B] text-black px-8 py-4 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#9A7B0A] transition-colors"
            >
              Book Now
              <ArrowUpRight strokeWidth={1.5} size={18} />
            </button>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />

      {/* Gallery Scroll Animation */}
      <style>{`
        @keyframes gallery-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-gallery-scroll {
          animation: gallery-scroll 20s linear infinite;
        }
      `}</style>
    </main>
    </>
  );
};

export default GalleryPage;
